
import makerjs from "makerjs";
function B16(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,R = Param[2].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
      //  s1 = S1 * 1 * myZoom,
        r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = 0, x1 = 0, x2 =b/2 ,x3 =b ,x4 =b , y0 = 0, y1 = r,y2 = l, y3 =r,y4 =0,glassH =l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  }  if (r !== 0) {
    var TxtR = "R="+R;
  } 



   var drawAbnormalShapeB16 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "TopLineLeft":new makerjs.paths.Line([x1,y1], [x2,y2]),
        "TopLineRight":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "RightLine":new makerjs.paths.Line([x3,y3], [x4,y4]), 
        "BottomLine": new makerjs.paths.Line([x4,y4], [x0, y0]),
       }
   };
   var drawAbnormalShapeB16MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x0- markShift, y0], [x0- markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x0, y2], [x0- 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x0, y0], [x0- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB16MarkR = {
       paths: {
        "RightLine": new makerjs.paths.Line([x4+ markShift, y4], [x3+ markShift, y3]),
        "RightShortUpline": new makerjs.paths.Line([x3, y3], [x3+ 2 * markShift, y3]),
        "RightShortDnline": new makerjs.paths.Line([x4, y4], [x4+ 2 * markShift, y4]),
       }
   };
   var drawAbnormalShapeB16MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x4, y4- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x4, y4], [x4, y4 - 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB16MarkB, TxtB, [x0, y0 - 2 * markShift], [x4, y4 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB16MarkL, TxtL, [x0-2*markShift, y0], [x0-2*markShift, y2]);//宽度文字
   makerjs.model.addCaption(drawAbnormalShapeB16MarkR, TxtR, [x4+ 2*markShift, y4], [x3+ 2*markShift, y3]);//长度文字
   
  plate={
    models: {
      drawAbnormalShapeB16: drawAbnormalShapeB16,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB16: drawAbnormalShapeB16,
        drawAbnormalShapeB16MarkL: drawAbnormalShapeB16MarkL,
        drawAbnormalShapeB16MarkR: drawAbnormalShapeB16MarkR,
        drawAbnormalShapeB16MarkB:drawAbnormalShapeB16MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B16;